import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { apiUrl } from "../../config";
import {
  fetchAdvertisementById,
  fetchAdvAttachmentsByAdId,
} from "../../service/AdService";
import { buildAttachmentDocuments } from "../../utils/advertisementAttachments";

const AttachmentViewer = () => {
  const [searchParams] = useSearchParams();
  const adId = searchParams.get("adId");
  const legacyUrl = searchParams.get("url");

  const [documents, setDocuments] = useState([]);
  const [title, setTitle] = useState("More Details");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadDocuments = async () => {
      setLoading(true);

      try {
        if (adId) {
          const [ad, attachments] = await Promise.all([
            fetchAdvertisementById(adId),
            fetchAdvAttachmentsByAdId(adId),
          ]);

          setDocuments(buildAttachmentDocuments(ad, attachments));
          setTitle(ad?.title || "More Details");
        } else if (legacyUrl) {
          setDocuments([{ url: legacyUrl }]);
        } else {
          setDocuments([]);
        }
      } catch (error) {
        console.error("Failed to load attachments", error);
        setDocuments([]);
      } finally {
        setLoading(false);
      }
    };

    loadDocuments();
  }, [adId, legacyUrl]);

  if (loading) {
    return <h3 className="text-center mt-5">Loading attachment...</h3>;
  }

  if (documents.length === 0) {
    return <h3 className="text-center mt-5">No file to display</h3>;
  }

  const getFileUrl = (url) =>
    url.startsWith("http") ? url : `${apiUrl}/${url}`;

  return (
    <div className="blog-single-main-page">
      <div className="attachment-page-header mb-4">
        <h4 className="fw-bold mb-2">{title}</h4>
        {documents.length > 1 && (
          <div className="d-flex flex-wrap gap-2">
            {documents.map((doc, index) => (
              <a
                key={`jump-${index}`}
                href={`#attachment-section-${index + 1}`}
                className="btn btn-outline-primary btn-sm"
              >
                Section {index + 1}
              </a>
            ))}
          </div>
        )}
      </div>

      {documents.map((doc, index) => (
        <section
          key={`${doc.url}-${index}`}
          id={`attachment-section-${index + 1}`}
          className="attachment-section mb-5"
        >
          {documents.length > 1 && (
            <h5 className="fw-semibold mb-3">
              Attachment {index + 1} of {documents.length}
            </h5>
          )}
          <div className="attachment-section-frame">
            <iframe
              src={`${getFileUrl(doc.url)}#toolbar=0&navpanes=0&view=fitH&zoom=85`}
              title={`${title} - ${index + 1}`}
            />
          </div>
        </section>
      ))}
    </div>
  );
};

export default AttachmentViewer;
